import { convertToGroup, Group, groupCollectionKey } from "@/entities/group";
import { schoolCollectionKey } from "@/entities/school";
import firebase from "firebase/app";

export async function getGroupOf(
  ref: firebase.firestore.DocumentReference
): Promise<Group | null> {
  const snapshot = await ref.get();
  const data = snapshot.data();

  if (!snapshot.exists || !data) {
    return null;
  }

  return convertToGroup(data, snapshot.ref);
}

export async function getGroups(schoolDocId: string): Promise<Group[]> {
  try {
    const snapshot = await firebase
      .firestore()
      .collection(schoolCollectionKey)
      .doc(schoolDocId)
      .collection(groupCollectionKey)
      .get();

    if (snapshot.empty) {
      return [];
    }
    return snapshot.docs.map(d => convertToGroup(d.data(), d.ref));
  } catch (e) {
    return [];
  }
}
